import { useQuery } from "@tanstack/react-query";
import { RuleBoxBuilder } from "./RuleBoxBuilder";
import { useTRPC } from "./trpc";

/**
 * Loads a rule box and opens the builder on its name, image and saved rules. Its history is a
 * page of its own (`RuleBoxHistoryPage`), opened from the box list.
 */
export function EditRuleBox({
  boxId,
  onDone,
  onCancel,
}: {
  boxId: string;
  onDone: () => void;
  onCancel: () => void;
}) {
  const trpc = useTRPC();
  const box = useQuery(trpc.boxes.get.queryOptions({ boxId }));

  if (box.isError) {
    return (
      <s-stack gap="base">
        <s-heading>Edit box</s-heading>
        <s-banner tone="critical">This box could not be loaded. Try again in a moment.</s-banner>
        <s-stack direction="inline">
          <s-button onClick={onCancel}>Back to your boxes</s-button>
        </s-stack>
      </s-stack>
    );
  }
  if (!box.data || !box.isFetchedAfterMount) {
    // The builder reads its start once, so it waits for this visit's read rather than a cached one.
    return (
      <s-stack gap="base">
        <s-heading>Edit box</s-heading>
        <s-paragraph>Loading the box…</s-paragraph>
      </s-stack>
    );
  }
  return (
    <RuleBoxBuilder
      start={{
        boxId,
        name: box.data.name,
        imageUrl: box.data.imageUrl,
        currentVersion: box.data.currentVersion,
        config: box.data.rule.config,
      }}
      onDone={onDone}
      onCancel={onCancel}
    />
  );
}
